import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { CheckBoxMultiNivelEstructura } from '../checkbox-multinivel/checkbox-multinivel.component'

@Component({
  selector: 'app-grupo-checkbox-multi-nivel',
  templateUrl: './grupo-checkbox-multi-nivel.component.html',
  styleUrls: ['./grupo-checkbox-multi-nivel.component.scss'],
})
export class GrupoCheckboxMultiNivelComponent implements OnInit {
 @Input() Datos:Array<CheckBoxMultiNivelEstructura> = []
 @Input() btnText = "Aceptar"
 DatosProcesados = []
 @Output() newVal = new EventEmitter()
  @Input() set value(val:Array<any>){
    setTimeout(() => {
      let d = JSON.stringify(this.Datos)
      this.DatosProcesados = JSON.parse(d)
      for(let i in val){
        val[i] = String(val[i])
      }
      for(let i in this.DatosProcesados){
        for(let j in this.DatosProcesados[i].subtasks){
            if (this.En(String(this.DatosProcesados[i].subtasks[j].value), val)){
              this.DatosProcesados[i].subtasks[j].completed=true
            }
        }
      }

      

    }, 1);
  } 


  En(valor:string, arreglo:Array<string>){
    for(let i of arreglo){
      if(valor == i){
        return true;
      }
    }
    return false;
  }

 ObtenerValor=0;

 ObtenerValores(){
   this.ObtenerValor+=1;
   setTimeout(() => {
     let vals= []
    for(let i in this.DatosProcesados){
      for(let j in this.DatosProcesados[i].subtasks){
          if (this.DatosProcesados[i].subtasks[j].completed){
            vals.push(this.DatosProcesados[i].subtasks[j].value)
          }
      }
    }
    this.newVal.emit(vals)
   }, 200);
 }

  constructor() { }

  ngOnInit() {
  }

}
